var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { on: { mouseover: _vm.stopAutoplay } },
    [
      _c(
        "Carousel",
        {
          attrs: {
            perPageCustom: [
              [300, 1],
              [1024, 2],
              [1400, 3],
              [1750, 4],
            ],
            autoplay: _vm.autoplay,
            autoplayTimeout: _vm.autoplayTimeout,
            paginationSize: 12,
            autoplayHoverPause: "",
            scrollPerPage: "",
            paginationColor: "#c3c3c3",
          },
        },
        _vm._l(_vm.imagesLinks, function (item, i) {
          return _c(
            "Slide",
            { key: i, staticClass: "px-4" },
            [
              _c("ImageSample", {
                staticClass: "cursor-pointer",
                attrs: { fileName: item },
                nativeOn: {
                  click: function ($event) {
                    return (() => _vm.showImg(i)).apply(null, arguments)
                  },
                },
              }),
            ],
            1
          )
        }),
        1
      ),
      _vm.imagesLinks.length
        ? _c("EnlargedImageViewer", {
            attrs: { images: _vm.imagesLinks, index: _vm.index },
            model: {
              value: _vm.lightboxVisible,
              callback: function ($$v) {
                _vm.lightboxVisible = $$v
              },
              expression: "lightboxVisible",
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }